
import axios from 'axios';
import { showFailToast } from 'vant';
import { TokenService } from '@/utils/auth';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 添加认证token
    const token = TokenService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 处理特定内容类型
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    // 处理标准响应结构
    if (response.data && typeof response.data === 'object') {
      if (response.data.code !== undefined && response.data.code !== 200 && response.data.code !== 0) {
        showFailToast(response.data.msg);
        return Promise.reject(response.data);
      }

      if (response.data.count >= 0) {
        return response.data;
      }
      
      return response.data.data;
    }
    return response.data;
  },
  async (error) => {
    // 处理HTTP错误
    if (error.response) {
      const { status, data } = error.response;
      
      // 401处理 - token过期
      if (status === 401) {
        TokenService.removeToken();
        showFailToast('登陆已过期');
        return;
      }
      
      // 统一错误消息处理
      const errorMessage = data?.msg || error.message || `请求错误: ${status}`;
      
      // 可以在这里使用Vue的全局提示组件
      console.error(errorMessage);
      showFailToast(errorMessage);
    } else if (error.request) {
      console.error('网络错误，请检查网络连接');
      showFailToast('网络错误，请检查网络连接');
    } else {
      console.error('请求配置错误:', error.message);
      showFailToast('请求配置错误');
    }
    
    return Promise.reject(error);
  }
);

// 封装常用方法
export const get = (url, params = {}, config = {}) => 
  api.get(url, { params, ...config });

export const post = (url, data = {}, config = {}) => 
  api.post(url, data, config);

export const put = (url, data = {}, config = {}) => 
  api.put(url, data, config);

export const del = (url, config = {}) => 
  api.delete(url, config);

export default api;